import React, { useContext } from "react";
import { withRouter, Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { v4 as uuidv4 } from "uuid";
import { ADD_STUDENT, GET_FIELDS } from "../GraphQL";
import { Breadcrumb, Header, Loader } from "semantic-ui-react";
import StudentForm from "../components/StudentForm";
import UserContext from "contexts/UserContext";
import gql from "graphql-tag";

const NewStudentPage = ({ history }) => {
  const user = useContext(UserContext);
  const { error, loading, data } = useQuery(GET_FIELDS);
  const [addStudent] = useMutation(ADD_STUDENT);

  let pageContent = null;
  if (error) {
    throw error;
  } else if (loading) {
    pageContent = <Loader active />;
  } else {
    const fields = data.myFields;

    const newStudent = {
      id: uuidv4(),
      name: "",
      reportFrequency: "daily",
      parents: [],
      allFields: fields,
      fieldIds: [],
      teacher: user.id,
    };

    pageContent = (
      <div>
        <Breadcrumb size="tiny">
          <Breadcrumb.Section>
            <Link to="/">Home</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section active>New Student</Breadcrumb.Section>
        </Breadcrumb>

        <Header as="h2" dividing>
          New Student
        </Header>

        <StudentForm
          student={newStudent}
          isNewStudent={true}
          saveLabel={"Next"}
          onCancel={() => history.push(`/students`)}
          onSubmit={(input) => {
            addStudent({
              variables: { id: newStudent.id, input },
              onCompleted: () =>
                history.push(`/students/${newStudent.id}/edit/questions`),
              update: (cache, { data: { addStudent } }) => {
                cache.modify({
                  fields: {
                    myStudents(existingStudents = [], { readField }) {
                      const newStudentRef = cache.writeFragment({
                        data: addStudent,
                        fragment: gql`
                          fragment NewStudent on Student {
                            id
                          }
                        `,
                      });
                      return [...existingStudents, newStudentRef];
                    },
                  },
                });
              },
            });
          }}
        />
      </div>
    );
  }
  return pageContent;
};

export default withRouter(NewStudentPage);
